import {
  ApiAppNamespaces,
  ApiBackofficeNamespaces,
  IQueuedRequest,
  OneAPIOptions
} from '../../common'
import { AppCmsApi } from './app'
import { BackofficeCmsApi } from './backoffice'
import { Queue } from '../../queue'

export class CmsApp implements ApiAppNamespaces {
  app: AppCmsApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppCmsApi(name, sessionId, requestsQueue, options)
  }

  invalidateAll() {
    this.app.invalidateAll()
  }
}

export class CmsBackoffice implements ApiBackofficeNamespaces {
  backoffice: BackofficeCmsApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.backoffice = new BackofficeCmsApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.backoffice.invalidateAll()
  }
}
